import React, { useState } from "react";

interface LinkWithIconProps {
    url: string;
    icon?: string;
}

export const LinkWithIcon: React.FC<LinkWithIconProps> = ({ url, icon = "content_copy" }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async (e: React.MouseEvent) => {
        e.preventDefault();
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch (err) {
            console.error("Failed to copy: ", err);
        }
    };

    return (
        <span className="d-inline-flex align-items-center gap-1 ff-poppins-medium w-100">
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-black text-underline text-truncate"
            >
                {url}
            </a>
            <span
                className="material-symbols-outlined cursor-pointer fs-20 color-black"
                onClick={handleCopy}
                title="Copy link"
            >
                {icon}
            </span>
        </span>
    );
};
